
(function() {
  var result = { translations: { "nl": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanees", "sq-al": "Albanees - Albani\xEB", "ar": "Arabisch", "ar-dz": "Arabisch - Algerije", "ar-bh": "Arabisch - Bahrein", "ar-eg": "Arabisch - Egypte", "ar-iq": "Arabisch - Irak", "ar-jo": "Arabisch - Jordani\xEB", "ar-kw": "Arabisch - Koeweit", "ar-lb": "Arabisch - Libanon", "ar-ly": "Arabisch - Libi\xEB", "ar-ma": "Arabisch - Marokko", "ar-om": "Arabisch - Oman", "ar-qa": "Arabisch - Qatar", "ar-sa": "Arabisch - Saoedi-Arabi\xEB", "ar-sd": "Arabisch - Soedan", "ar-sy": "Arabisch - Syri\xEB", "ar-tn": "Arabisch - Tunesi\xEB", "ar-ae": "Arabisch - Verenigde Arabische Emiraten", "ar-ye": "Arabisch - Jemen", "as": "Assamees", "az": "Azerbeidzjaans", "hy": "Armeens", "eu": "Baskisch", "be": "Wit-Russisch", "be-by": "Wit-Russisch - Wit-Rusland", "bn": "Bengali", "bg": "Bulgaars", "bg-bg": "Bulgaars - Bulgarije", "bs": "Bosnisch", "ca": "Catalaans", "ca-es": "Catalaans - Catalaans", "zh": "Chinees", "zh-cn": "Chinees - Vereenvoudigd", "zh-hk": "Chinees - Hong Kong", "zh-mo": "Chinees - Macau", "zh-sg": "Chinees - Singapore", "zh-tw": "Chinees - Traditioneel", "zh-chs": "Chinees (Vereenvoudigd)", "zh-cht": "Chinees (Traditioneel)", "zh-hans": "Chinees (vereenvoudigd Han)", "zh-hant": "Chinees (traditioneel Han)", "hr": "Kroatisch", "hr-hr": "Kroatisch - Kroati\xEB", "cs": "Tsjechisch", "cs-cz": "Tsjechisch - Tsjechi\xEB", "da": "Deens", "da-dk": "Deens - Denemarken", "nl": "Nederlands", "nl-be": "Nederlands - Belgi\xEB", "nl-ch": "Nederlands - Zwitserland", "nl-lu": "Nederlands - Luxemburg", "nl-nl": "Nederlands - Nederland", "en": "Engels", "en-ae": "Engels - Verenigde Arabische Emiraten", "en-au": "Engels - Australi\xEB", "en-be": "Engels - Belgi\xEB", "en-ca": "Engels - Canada", "en-ch": "Engels - Zwitserland", "en-cn": "Engels - China", "en-de": "Engels - Duitsland", "en-ee": "Engels - Estland", "en-es": "Engels - Spanje", "en-fr": "Engels - Frankrijk", "en-hk": "Engels - Hongkong", "en-in": "Engels - India", "en-ie": "Engels - Ierland", "en-ke": "Engels - Kenia", "en-lu": "Engels - Luxemburg", "en-my": "Engels - Maleisi\xEB", "en-mt": "Engels - Malta", "en-mx": "Engels - Mexico", "en-nl": "Engels - Nederland", "en-nz": "Engels - Nieuw-Zeeland", "en-ph": "Engels - Filipijnen", "en-pk": "Engels - Pakistan", "en-se": "Engels - Zweden", "en-sg": "Engels - Singapore", "en-tn": "Engels - Tunesi\xEB", "en-za": "Engels - Zuid-Afrika", "en-gb": "Engels - Verenigd Koninkrijk", "en-us": "Engels - Verenigde Staten", "en-zw": "Engels - Zimbabwe", "et": "Ests", "et-ee": "Ests - Estland", "fo": "Faer\xF6ers", "fa": "Farsi", "fi": "Fins", "fi-fi": "Fins - Finland", "fil": "Filipijns", "fr": "Frans", "fr-be": "Frans - Belgi\xEB", "fr-ca": "Frans - Canada", "fr-fr": "Frans - Frankrijk", "fr-lu": "Frans - Luxemburg", "fr-mc": "Frans - Monaco", "fr-ch": "Frans - Zwitserland", "fr-tn": "Frans - Tunesi\xEB", "gl": "Galicisch", "ka": "Georgisch", "de": "Duits", "de-at": "Duits - Oostenrijk", "de-de": "Duits - Duitsland", "de-gr": "Duits - Griekenland", "de-li": "Duits - Liechtenstein", "de-lu": "Duits - Luxemburg", "de-ch": "Duits - Zwitserland", "el": "Grieks", "el-cy": "Grieks - Cyprus", "el-gr": "Grieks - Griekenland", "gu": "Gujarati", "ha": "Hausa", "he": "Hebreeuws", "he-il": "Hebreeuws - Isra\xEBl", "iw-il": "Hebreeuws - Isra\xEBl", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Hongaars", "hu-hu": "Hongaars - Hongarije", "is": "IJslands", "is-is": "IJslands - IJsland", "id": "Indonesisch", "in-id": "Indonesisch - Indonesi\xEB", "ga": "Iers", "ga-ie": "Iers - Ierland", "it": "Italiaans", "it-it": "Italiaans - Itali\xEB", "it-ch": "Italiaans - Zwitserland", "ja": "Japans", "ja-jp": "Japans - Japan", "kn": "Kannada", "kk": "Kazakh", "kok": "Konkani", "ko": "Koreaans", "ko-kr": "Koreaans - Zuid-Korea", "ku": "Koerdisch", "ky": "Kirgizisch", "ky-kg": "Kirgizisch", "lo": "Laotiaanse", "lv": "Lets", "lv-lv": "Lets - Letland", "lt": "Litouws", "lt-lt": "Litouws - Litouwen", "mk": "Macedonisch", "mk-mk": "Macedonisch - Macedoni\xEB", "ml": "Malayalam", "ms": "Maleis", "ms-bn": "Maleis - Brunei", "ms-my": "Maleis - Maleisi\xEB", "mt": "Maltees", "mt-mt": "Maltees - Malta", "mr": "Marathi", "mn": "Mongools", "my": "Birmaans", "my-mm": "Birmaans - Myanmar (Birma)", "ne": "Nepalees", "no": "Noors", "nb": "Noors Bokm\xE5l", "nb-no": "Noorse Bokmal - Noorwegen", "no-no": "Noors - Noorwegen", "pl": "Pools", "pl-pl": "Pools - Polen", "pt": "Portugees", "pt-br": "Portugees - Brazili\xEB", "pt-pt": "Portugees - Portugal", "pa": "Punjabi", "pa-in": "Punjabi-India", "pa-pk": "Punjabi-Pakistan", "ro": "Roemeens", "ro-ro": "Roemeens - Roemeni\xEB", "ru": "Russisch", "ru-ru": "Russisch - Rusland", "rw-rw": "Kinyarwanda", "sa": "Sanskriet", "si": "Singalees", "sr": "Servisch", "sr-ba": "Servisch - Bosni\xEB-Herzegovina", "sr-me": "Servisch - Montenegro", "sr-rs": "Servisch - Servi\xEB", "sr-cs": "Servisch - Servi\xEB en Montenegro (voormalig)", "sk": "Slowaaks", "sk-sk": "Slowaaks - Slowakije", "sl": "Sloveens", "sl-si": "Sloveens - Sloveni\xEB", "es": "Spaans", "es-ar": "Spaans - Argentini\xEB", "es-bo": "Spaans - Bolivia", "es-cl": "Spaans - Chili", "es-co": "Spaans - Colombia", "es-cr": "Spaans - Costa Rica", "es-cu": "Spaans - Cuba", "es-do": "Spaans - Dominicaanse Republiek", "es-ec": "Spaans - Ecuador", "es-sv": "Spaans - El Salvador", "es-gt": "Spaans - Guatemala", "es-hn": "Spaans - Honduras", "es-mx": "Spaans - Mexico", "es-ni": "Spaans - Nicaragua", "es-pa": "Spaans - Panama", "es-py": "Spaans - Paraguay", "es-pe": "Spaans - Peru", "es-pr": "Spaans - Puerto Rico", "es-es": "Spaans - Spanje", "es-us": "Spaans - Verenigde Staten", "es-uy": "Spaans - Uruguay", "es-ve": "Spaans - Venezuela", "sw": "Swahili", "sv": "Zweeds", "sv-fi": "Zweeds - Finland", "sv-se": "Zweeds - Zweden", "sy": "Syrisch", "ta": "Tamil", "tt": "Tataars", "te": "Telugu", "th": "Thais", "th-th": "Thai - Thailand", "tl": "Tagalog", "tr": "Turks", "tr-tr": "Turks - Turkije", "uk": "Oekra\xEFens", "uk-ua": "Oekra\xEFens - Oekra\xEFne", "ur": "Urdu", "uz": "Oezbeekse", "vi": "Vietnamees", "vi-vn": "Vietnamees - Vietnam", "yi": "Jiddisch", "zu": "Zoeloes" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.160",
    "ar-eg": "static-1.160",
    "ar-sa": "static-1.160",
    "ar": "static-1.160",
    "be": "static-1.160",
    "bg": "static-1.160",
    "bn": "static-1.160",
    "ca-es": "static-1.160",
    "ca": "static-1.160",
    "cs": "static-1.160",
    "da": "static-1.160",
    "de": "static-1.160",
    "el": "static-1.160",
    "en-gb": "static-1.160",
    "en": "static-1.160",
    "es-ar": "static-1.160",
    "es-es": "static-1.160",
    "es-mx": "static-1.160",
    "es": "static-1.160",
    "et": "static-1.160",
    "eu": "static-1.160",
    "fi": "static-1.160",
    "fr-ca": "static-1.160",
    "fr": "static-1.160",
    "gl": "static-1.160",
    "gu": "static-1.160",
    "he-il": "static-1.160",
    "he": "static-1.160",
    "hi": "static-1.160",
    "hr": "static-1.160",
    "hu": "static-1.160",
    "hy": "static-1.160",
    "id": "static-1.160",
    "is": "static-1.160",
    "it": "static-1.160",
    "ja": "static-1.160",
    "ka": "static-1.160",
    "kk": "static-1.160",
    "kn": "static-1.160",
    "ko": "static-1.160",
    "ky": "static-1.160",
    "lt": "static-1.160",
    "lv": "static-1.160",
    "mk": "static-1.160",
    "mn": "static-1.160",
    "mr": "static-1.160",
    "ms-my": "static-1.160",
    "ms": "static-1.160",
    "nl-be": "static-1.160",
    "nl-nl": "static-1.160",
    "nl": "static-1.160",
    "no": "static-1.160",
    "pl": "static-1.160",
    "pt-br": "static-1.160",
    "pt-pt": "static-1.160",
    "ro": "static-1.160",
    "ru": "static-1.160",
    "sk": "static-1.160",
    "sl": "static-1.160",
    "sq": "static-1.160",
    "sr": "static-1.160",
    "sv": "static-1.160",
    "sw": "static-1.160",
    "ta": "static-1.160",
    "te": "static-1.160",
    "th": "static-1.160",
    "tl": "static-1.160",
    "tr": "static-1.160",
    "uk": "static-1.160",
    "ur": "static-1.160",
    "vi": "static-1.160",
    "zh-cn": "static-1.160",
    "zh-hans": "static-1.160",
    "zh-hant": "static-1.160",
    "zh-hk": "static-1.160",
    "zh-tw": "static-1.160"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "nl": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dagen", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "nl": "static-7.1324"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1324",
    "ar-eg": "static-7.1324",
    "bg": "static-7.1324",
    "bn": "static-7.1324",
    "ca-es": "static-7.1324",
    "cs": "static-7.1324",
    "da": "static-7.1324",
    "de": "static-7.1324",
    "el": "static-7.1324",
    "en-gb": "static-7.1324",
    "en": "static-7.1324",
    "es-mx": "static-7.1324",
    "es": "static-7.1324",
    "et": "static-7.1324",
    "fi": "static-7.1324",
    "fr-ca": "static-7.1324",
    "fr": "static-7.1324",
    "he-il": "static-7.1324",
    "hi": "static-7.1324",
    "hr": "static-7.1324",
    "hu": "static-7.1324",
    "id": "static-7.1324",
    "it": "static-7.1324",
    "ja": "static-7.1324",
    "ko": "static-7.1324",
    "lt": "static-7.1324",
    "ms": "static-7.1324",
    "nl": "static-7.1324",
    "no": "static-7.1324",
    "pl": "static-7.1324",
    "pt-br": "static-7.1324",
    "pt-pt": "static-7.1324",
    "ro": "static-7.1324",
    "ru": "static-7.1324",
    "sk": "static-7.1324",
    "sl": "static-7.1324",
    "sv": "static-7.1324",
    "th": "static-7.1324",
    "tl": "static-7.1324",
    "tr": "static-7.1324",
    "uk": "static-7.1324",
    "vi": "static-7.1324",
    "x-pseudo": "static-7.1324",
    "zh-cn": "static-7.1324",
    "zh-hk": "static-7.1324",
    "zh-tw": "static-7.1324"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:nl', {version: 'static-7.1324'}); }
})();



(function() {
  var result = { translations: { "nl": { "videoPlayer": { "htmlTitle": "HubSpot-video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot-video", "controls": { "audioPlayer": "Audiospeler", "videoPlayer": "Videospeler", "play": "Afspelen", "playVideo": "Video afspelen", "pause": "Pauzeren", "replay": "Opnieuw afspelen", "currentTime": "Huidige tijd", "duration": "Duur", "remainingTime": "Resterende tijd", "fullscreen": "Volledig scherm", "exitFullscreen": "Volledig scherm afsluiten", "mute": "Dempen", "unmute": "Dempen uitzetten", "volumeLevel": "Volumeniveau", "captions": "Bijschriften", "captionsOff": "Uit", "seekBar": "Positie aanpassen", "chapter": "Hoofdstuk", "elapsedTime": "Verstreken tijd: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Afspeelopties", "playbackRate": "Afspeelsnelheid:", "quality": "Kwaliteit:", "normal": "Normaal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Bedankt voor je reactie.", "inlineMessageButton": "Video bekijken" }, "ctaModal": { "imgAlt": "Video-CTA" }, "errors": { "generic": { "heading": "Kon video niet laden" }, "UNAUTHORIZED": { "heading": "Video niet ingeschakeld" }, "VIDEO_NOT_FOUND": { "heading": "Video niet gevonden" }, "INVALID_URL": { "heading": "Video niet gevonden" }, "UNSUPPORTED_EMBED": { "heading": "Video niet beschikbaar", "extra": "Deze video kan niet extern worden weergegeven." }, "refreshLink": "Opnieuw proberen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "nl": "static-1.27682"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.27682",
    "ar-eg": "static-1.27682",
    "bg": "static-1.27682",
    "bn": "static-1.27682",
    "ca-es": "static-1.27682",
    "cs": "static-1.27682",
    "da": "static-1.27682",
    "de": "static-1.27682",
    "el": "static-1.27682",
    "en-gb": "static-1.27682",
    "en": "static-1.27682",
    "es-mx": "static-1.27682",
    "es": "static-1.27682",
    "et": "static-1.27682",
    "fi": "static-1.27682",
    "fr-ca": "static-1.27682",
    "fr": "static-1.27682",
    "he-il": "static-1.27682",
    "hi": "static-1.27682",
    "hr": "static-1.27682",
    "hu": "static-1.27682",
    "id": "static-1.27682",
    "it": "static-1.27682",
    "ja": "static-1.27682",
    "ko": "static-1.27682",
    "lt": "static-1.27682",
    "ms": "static-1.27682",
    "nl": "static-1.27682",
    "no": "static-1.27682",
    "pl": "static-1.27682",
    "pt-br": "static-1.27682",
    "pt-pt": "static-1.27682",
    "ro": "static-1.27682",
    "ru": "static-1.27682",
    "sk": "static-1.27682",
    "sl": "static-1.27682",
    "sv": "static-1.27682",
    "th": "static-1.27682",
    "tl": "static-1.27682",
    "tr": "static-1.27682",
    "uk": "static-1.27682",
    "vi": "static-1.27682",
    "zh-cn": "static-1.27682",
    "zh-hk": "static-1.27682",
    "zh-tw": "static-1.27682"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:nl', {version: 'static-1.27682'}); }
})();


